import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import Button from '../Elements/Button/Button';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { translate, prefix } from '../../utils/locale';
import s from './Cart.scss';

const Cart = ({ checkout, setup, maxHeight }) => (
	<div className={s.cart}>
		<h3 className={s.cart_title}>{ translate(setup, 'cartTitle') }</h3>
		<div className={[s.cart_items, (checkout.selection.items && (checkout.selection.items.length * 173) + 200 > maxHeight ? s.cart_items__long : '')].join(' ')} style={{ maxHeight: `${(maxHeight - 266) < 150 ? 150 : maxHeight - 266}px` }}>
			<ErrorBoundary message="CartItems:" debugData={checkout.selection.items}>
				<CartItems />
			</ErrorBoundary>
		</div>
		{
			checkout.selection.items ? (
				<div className={s.cart_totals}>
					<div className={s.cart_totals_row}>
						<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutProductTotal') }</span>
						<span className={s.cart_totals_row_right}>{ checkout.selection.totals.itemsTotalPrice }</span>
					</div>
					{
						checkout.selection.totals.totalDiscountPriceAsNumber !== false ? (
							<div className={[s.cart_totals_row, s.cart_totals_row__discount].join(' ')}>
								<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutDiscount') }</span>
								<span className={s.cart_totals_row_right}>{ checkout.selection.totals.totalDiscountPrice }</span>
							</div>
						) : null
					}
					<div className={s.cart_totals_button}>
						<Button text={translate(setup, 'goToCheckout')} type={checkout.klarnaLoaded ? 'a' : 'link'} location={prefix(setup, 'selection')} href={prefix(setup, 'selection')} />
						<span className={s.cart_totals_button_push}>{ translate(setup, 'cartFreeShipping') }</span>
					</div>
				</div>
			) : null
		}
	</div>
);

const mapState = ({ checkout, environment }, { maxHeight }) => {
	const { setup, header } = environment;
	return { checkout, setup, header, maxHeight };
};

export default hot(module)(connect(mapState)(Cart));
